export default "__VITE_ASSET__794f6a3b__"